import { cn } from '@/lib/utils';
import { Spinner } from '../spinner';

type LoadingProps = {
  className?: string;
  fullScreen?: boolean;
};

export const Loading = ({ className, fullScreen = true }: LoadingProps) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        <div className={cn('flex flex-col items-center gap-2', className)}>
          <Spinner size="lg" className="text-primary" />
          <p className="text-sm text-muted-foreground">Loading application...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={cn('flex items-center justify-center p-4', className)}>
      <Spinner className="text-primary" />
    </div>
  );
};
